import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const propertyTypesAdapter = createEntityAdapter({});

const initialState = propertyTypesAdapter.getInitialState();

export const propertyTypesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPropertyTypes: builder.query({
      query: () => "/propertyTypes",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedPropertyTypes = responseData.map((propertyType) => {
          propertyType.id = propertyType._id;
          return propertyType;
        });
        return propertyTypesAdapter.setAll(initialState, loadedPropertyTypes);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "PropertyType", id: "LIST" },
            ...result.ids.map((id) => ({ type: "PropertyType", id })),
          ];
        } else return [{ type: "PropertyType", id: "LIST" }];
      },
    }),
    addNewPropertyType: builder.mutation({
      query: (initialPropertyTypeData) => ({
        url: "/propertyTypes",
        method: "POST",
        body: {
          ...initialPropertyTypeData,
        },
      }),
      invalidatesTags: [{ type: "PropertyType", id: "LIST" }],
    }),
    updatePropertyType: builder.mutation({
      query: (initialPropertyTypeData) => ({
        url: "/propertyTypes",
        method: "PATCH",
        body: {
          ...initialPropertyTypeData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "PropertyType", id: arg.id },
      ],
    }),
    deletePropertyType: builder.mutation({
      query: ({ id }) => ({
        url: `/propertyTypes`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "PropertyType", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetPropertyTypesQuery,
  useAddNewPropertyTypeMutation,
  useUpdatePropertyTypeMutation,
  useDeletePropertyTypeMutation,
} = propertyTypesApiSlice;

// returns the query result object
export const selectPropertyTypesResult =
  propertyTypesApiSlice.endpoints.getPropertyTypes.select();

// creates memoized selector
const selectPropertyTypesData = createSelector(
  selectPropertyTypesResult,
  (propertyTypesResult) => propertyTypesResult.data // normalized state object with ids & entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllPropertyTypes,
  selectById: selectPropertyTypeById,
  selectIds: selectPropertyTypeIds,
  // Pass in a selector that returns the propertyTypes slice of state
} = propertyTypesAdapter.getSelectors(
  (state) => selectPropertyTypesData(state) ?? initialState
);
